module.exports = __webpack_public_path__ + "static/Grafik_family_mobile.52fb2b52.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/PageHeader/Hero/Grafik_family_mobile.png
// module id = 426
// module chunks = 35783957827783